/* eslint-disable indent */
export const GENE_COLORS = {
  "5UTR" :  {light_color_1: 'rgb(154, 154, 154)', light_color_2: 'rgb(108, 108, 108)',
    light_color_3: 'rgb(211, 211, 211)', light_color_4: 'rgb(176, 176, 176)',
    dark_color_1: 'rgb(106, 106, 106)', dark_color_2: 'rgb(152, 152, 152)',
    dark_color_3: 'rgb(63, 63, 63)', dark_color_4: 'rgb(82, 82, 82)',
    label: "5'UTR", shortLabel: "5'UTR",  classLabel: 'other-5utr'},
  "ORF1a":  {light_color_1: 'rgb(129, 57, 93)', light_color_2: 'rgb(81, 25, 51)',
    light_color_3: 'rgb(203, 187, 203)', light_color_4: 'rgb(158, 80, 116)',
    dark_color_1: 'rgb(145, 67, 103)', dark_color_2: 'rgb(194, 113, 149)',
    dark_color_3: 'rgb(63, 38, 51)', dark_color_4: 'rgb(117, 43, 81)',
    label: 'ORF1a', shortLabel: 'ORF1a',  classLabel: 'gene-1a'},
  "ORF1b":  {light_color_1: 'rgb(129, 57, 93)', light_color_2: 'rgb(81, 25, 51)',
    light_color_3: 'rgb(203, 187, 203)', light_color_4: 'rgb(158, 80, 116)',
    dark_color_1: 'rgb(145, 67, 103)', dark_color_2: 'rgb(194, 113, 149)',
    dark_color_3: 'rgb(63, 38, 51)', dark_color_4: 'rgb(117, 43, 81)',
    label: 'ORF1b', shortLabel: 'ORF1b',  classLabel: 'gene-1b'},
  "S":      {light_color_1: 'rgb(125, 117, 202)', light_color_2: 'rgb(77, 73, 153)',
    light_color_3: 'rgb(182, 192, 227)', light_color_4: 'rgb(150, 143, 231)',
    dark_color_1: 'rgb(143, 130, 217)', dark_color_2: 'rgb(190, 176, 255)',
    dark_color_3: 'rgb(65, 62, 93)', dark_color_4: 'rgb(114, 104, 188)',
    label: 'Spike', shortLabel: 'Spike',  classLabel: 'gene-spike'},
  "ORF3a":  {light_color_1: 'rgb(148, 171, 74)', light_color_2: 'rgb(102, 127, 30)',
    light_color_3: 'rgb(188, 208, 188)', light_color_4: 'rgb(173, 199, 102)',
    dark_color_1: 'rgb(168, 189, 87)', dark_color_2: 'rgb(215, 238, 135)',
    dark_color_3: 'rgb(77, 84, 49)', dark_color_4: 'rgb(138, 160, 62)',
    label: 'ORF3a', shortLabel: '3a',  classLabel: 'gene-3a'},
  "E":      {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(0, 78, 63)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'E', shortLabel: 'E',  classLabel: 'gene-e'},
  "M":      {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(0, 78, 63)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'M', shortLabel: 'M',  classLabel: 'gene-m'},
  "ORF6":   {light_color_1: 'rgb(210, 141, 70)', light_color_2: 'rgb(157, 95, 27)',
    light_color_3: 'rgb(211, 195, 173)', light_color_4: 'rgb(239, 167, 97)',
    dark_color_1: 'rgb(252, 153, 79)', dark_color_2: 'rgb(255, 202, 127)',
    dark_color_3: 'rgb(103, 73, 47)', dark_color_4: 'rgb(220, 127, 56)',
    label: 'ORF6', shortLabel: '6',  classLabel: 'gene-6'},
  "ORF7a":  {light_color_1: 'rgb(210, 141, 70)', light_color_2: 'rgb(157, 95, 27)',
    light_color_3: 'rgb(211, 195, 173)', light_color_4: 'rgb(239, 167, 97)',
    dark_color_1: 'rgb(252, 153, 79)', dark_color_2: 'rgb(255, 202, 127)',
    dark_color_3: 'rgb(103, 73, 47)', dark_color_4: 'rgb(220, 127, 56)',
    label: 'ORF7a', shortLabel: '7a',  classLabel: 'gene-7a'},
  "ORF7b":  {light_color_1: 'rgb(207, 68, 49)', light_color_2: 'rgb(151, 6, 11)',
    light_color_3: 'rgb(215, 178, 161)', light_color_4: 'rgb(237, 97, 74)',
    dark_color_1: 'rgb(237, 79, 56)', dark_color_2: 'rgb(255, 131, 101)',
    dark_color_3: 'rgb(94, 44, 37)', dark_color_4: 'rgb(204, 50, 35)',
    label: 'ORF7b', shortLabel: '7b',  classLabel: 'gene-7b'},
  "ORF8":   {light_color_1: 'rgb(210, 141, 70)', light_color_2: 'rgb(157, 95, 27)',
    light_color_3: 'rgb(211, 195, 173)', light_color_4: 'rgb(239, 167, 97)',
    dark_color_1: 'rgb(252, 153, 79)', dark_color_2: 'rgb(255, 202, 127)',
    dark_color_3: 'rgb(103, 73, 47)', dark_color_4: 'rgb(220, 127, 56)',
    label: 'ORF8', shortLabel: '8',  classLabel: 'gene-8'},
  "N":      {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(0, 78, 63)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'N', shortLabel: 'N',  classLabel: 'gene-n'},
  "ORF9b":  {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(0, 78, 63)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'ORF9b', shortLabel: '9b',  classLabel: 'gene-9b'},
  "ORF10":  {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(0, 78, 63)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'ORF10', shortLabel: '10',  classLabel: 'gene-10'},
  "3UTR":   {light_color_1: 'rgb(154, 154, 154)', light_color_2: 'rgb(108, 108, 108)',
    light_color_3: 'rgb(211, 211, 211)', light_color_4: 'rgb(176, 176, 176)',
    dark_color_1: 'rgb(106, 106, 106)', dark_color_2: 'rgb(152, 152, 152)',
    dark_color_3: 'rgb(63, 63, 63)', dark_color_4: 'rgb(82, 82, 82)',
    label: "3'UTR", shortLabel: "3'",  classLabel: 'other-3utr'},
  "Non-coding region" : {light_color_1: 'rgb(154, 154, 154)', light_color_2: 'rgb(108, 108, 108)',
    light_color_3: 'rgb(211, 211, 211)', light_color_4: 'rgb(176, 176, 176)',
    dark_color_1: 'rgb(106, 106, 106)', dark_color_2: 'rgb(152, 152, 152)',
    dark_color_3: 'rgb(63, 63, 63)', dark_color_4: 'rgb(82, 82, 82)',
    label: 'Noncoding', shortLabel: 'Noncoding',  classLabel: 'other-noncoding'}
}

/* eslint-enable indent */
export const GENES = "5UTR,ORF1a,ORF1b,S,ORF3a,E,M,ORF6,ORF7a,ORF7b,ORF8,N,ORF10,3UTR,Non-coding region".split(",");

const MUTATION_RE = /([A-Za-z- 0-9]+):([A-Z\\*]+)([0-9]+)([A-Z\\*]*)( \(([A-Z]+)>([A-Z]+)\))?/;

export class Mutation {
  constructor(name) {
    this.name = name;
    let match = name.match(MUTATION_RE);
    this.gene = match[1];
    this.position = parseInt(match[3]);
    this.refAA  = match[2].trim();
    this.geneSort = GENES.indexOf(this.gene);
    this.altAA = (match[4] || '').trim();
    this.refNuc = match[6];
    this.altNuc = match[7];
    this.label = name.split(':')[1];
    this.label = this.label.toUpperCase().replace(/^DEL/, '∆');
    this.label = this.label.replace(/-/gi, '/');
    let labelTokens = this.label.split(' ')
    if (labelTokens.length > 1) {
      this.label = labelTokens[0];
      let r = '',
        a = '',
        isMatching = false;
      for (let i = 0; i < 3; i++) {
        let nucsMatch = this.refNuc[i] === this.altNuc[i];
        if (nucsMatch) {
          if (!isMatching) {
            r += '<span class="mutation--name--syn">';
            isMatching = true;
          }
        } else if (isMatching) {
          r += '</span>';
          isMatching = false;
        }
        r += this.refNuc[i];
      }
      if (!isMatching) {
        r += '<span class="mutation--name--syn">';
        isMatching = true;
      }
      for (let i = 0; i < 3; i++) {
        let nucsMatch = this.refNuc[i] === this.altNuc[i];
        if (nucsMatch) {
          if (!isMatching) {
            a += '<span class="mutation--name--syn">';
            isMatching = true;
          }
        } else if (isMatching) {
          a += '</span>';
          isMatching = false;
        }
        a += this.altNuc[i];
      }
      if (isMatching) {
        a += '</span>';
      }
      // this.nucLabel = labelTokens[1].replace('>','→');
      this.nucLabelHtml = `<span class="mutation--name--syn">(</span>${r}<span class="mutation--name--arr">→</span>${a}<span class="mutation--name--syn">)</span>`;
      this.nucLabel = `(${this.refNuc  }>${  this.altNuc})`;
    } else {
      this.nucLabel = '';
      this.nucLabelHtml = '';
    }
  }

}
